/* eslint-disable no-undef */
import React, { Component } from 'react';
import {
  Route, Switch, Redirect, withRouter,
} from 'react-router-dom';
import { compose } from 'react-apollo';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import io from 'socket.io-client';
import { withAlert } from 'react-alert';
import * as actions from '../../actions';
import { clearLocalStorage, getStore } from '../../utils';

// Header
import Header from '../Header';
import DropdownMenu from '../Header/Dropdown';
import Drawer from '../Header/Drawer';
import Backdrop from '../Header/Drawer/Backdrop';

// Components
import StoreAvailability from '../Modal/Store/Availability';
import ChangeStore from '../Modal/Store/Change';
import NotificationMp3 from '../../assets/sounds/notification.mp3';

// Pages
import Home from '../../pages/Home';
import Orders from '../../pages/Orders';
import Products from '../../pages/Products';
import Billing from '../../pages/Billing';
import Ratings from '../../pages/Ratings';
import Profile from '../../pages/Store/Account';
import UserAccount from '../../pages/User/Account';
import Help from '../../pages/Help';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdown: false,
      drawer: false,
      storeAvailabilityModal: false,
      changeStoreModal: false,
    };
    this.showDropdownMenu = this.showDropdownMenu.bind(this);
    this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
    this.notification = new Audio(NotificationMp3);
  }

  componentDidMount = () => {
    this.registerToSocket();

    document.getElementById('html').style.overflowY = 'scroll';

    if (!getStore()) {
      this.props.history.push('/dashboard/home');
      this.setState({ changeStoreModal: true, hasStore: false });
    }
  }

  registerToSocket = () => {
    const socket = io(process.env.REACT_APP_WEB_SOCKET_ENDPOINT);

    socket.on('NEW_ORDER', (storeId) => {
      if (storeId === this.props.store.id) {
        this.props.alert.info('A loja recebeu um novo pedido');
        this.notification.play();
      }
    });

    socket.on('STORE_AVAILABLE', (storeId) => {
      if (storeId === this.props.store.id && this.props.store.status.open) {
        this.props.saveStore({
          ...this.props.store,
          status: {
            ...this.props.store.status,
            open: false,
          },
        });
      }
    });
  }

  logout = () => {
    this.setState({ drawer: false });

    setTimeout(() => {
      clearLocalStorage();

      this.props.history.push('/login');
      this.props.resetState();
    }, 1000);
  }

  showDropdownMenu = () => {
    this.setState({ dropdown: true }, () => {
      document.addEventListener('click', this.hideDropdownMenu);
    });
  }

  hideDropdownMenu = () => {
    this.setState({ dropdown: false }, () => {
      document.removeEventListener('click', this.hideDropdownMenu);
    });
  }

  drawerHandler = () => {
    this.setState(state => ({
      drawer: !state.drawer,
    }));
  }

  backdropHandler = () => {
    this.setState({ drawer: false });
  }

  openStoreAvailabilityModal = () => {
    this.storeAvailabilityModal.openStoreAvailabilityModal();

    this.setState({ storeAvailabilityModal: true });
  };

  closeStoreAvailabilityModal = () => {
    this.setState({ storeAvailabilityModal: false });
  };

  openChangeStoreModal = () => {
    this.setState({ changeStoreModal: true, hasStore: true });
  };

  closeChangeStoreModal = () => {
    this.setState({ changeStoreModal: false });
  };

  render() {
    const { dropdown, drawer } = this.state;

    return (
      <div>
        <Header
          showDropdownMenu={this.showDropdownMenu}
          drawerHandler={this.drawerHandler}
          dropdown={dropdown}
          openStoreAvailabilityModal={this.openStoreAvailabilityModal}
          store={this.props.store}
        />
        {dropdown && (
          <DropdownMenu openChangeStoreModal={this.openChangeStoreModal} logout={this.logout} />
        )}
        {this.props.store.id && (
          <Drawer
            show={drawer}
            drawerHandler={this.drawerHandler}
            openStoreAvailabilityModal={this.openStoreAvailabilityModal}
            openChangeStoreModal={this.openChangeStoreModal}
            logout={this.logout}
            store={this.props.store}
          />
        )}
        {drawer && <Backdrop backdropHandler={this.backdropHandler} />}
        {this.props.store.id && (
          <Switch>
            <Route
              path="/dashboard"
              exact
              render={() => (this.props.store.roleType !== 'employee' ? <Redirect to="/dashboard/home" /> : <Redirect to="/dashboard/orders" />)}
            />
            {this.props.store.roleType !== 'employee' && <Route path="/dashboard/home" component={Home} />}
            {this.props.store.roleType !== 'employee' && <Route path="/dashboard/billing" component={Billing} />}
            {this.props.store.roleType !== 'employee' && <Route path="/dashboard/store/account" component={Profile} />}
            <Route path="/dashboard/orders" component={Orders} />
            <Route path="/dashboard/products" component={Products} />
            <Route path="/dashboard/ratings" component={Ratings} />
            <Route path="/dashboard/user/account" component={UserAccount} />
            <Route path="/dashboard/help" component={Help} />
            <Route render={() => (this.props.store.roleType !== 'employee' ? <Redirect to="/dashboard/home" /> : <Redirect to="/dashboard/orders" />)} />
          </Switch>
        )}
        <StoreAvailability
          ref={(el) => { if (el) this.storeAvailabilityModal = el.getWrappedInstance(); }}
          open={this.state.storeAvailabilityModal}
          close={this.closeStoreAvailabilityModal}
          drawer={drawer}
          drawerHandler={this.drawerHandler}
          store={this.props.store}
          saveStore={this.props.saveStore}
        />
        <ChangeStore
          open={this.state.changeStoreModal}
          close={this.closeChangeStoreModal}
          drawer={drawer}
          drawerHandler={this.drawerHandler}
          hasStore={this.state.hasStore}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  store: state.store,
});

const mapDispathToProps = dispatch => bindActionCreators(actions, dispatch);

export default compose(
  withAlert(),
  withRouter,
  connect(mapStateToProps, mapDispathToProps),
)(Dashboard);
